const { last } = require('underscore');

function serviceReducer(service) { //eslint-disable-line

	const allowedServices = [
		'oil change',
		'alignment',
		'permasafe',
		'nissan clean',
		'nissan shield',
		'infiniti clean',
		'infiniti shield',
		'mobile installation service'
	];

	if (service) {
		const title = service.title.toLowerCase();

		return service.isPromoted && allowedServices.some(allowedService => title.indexOf(allowedService) >= 0) ? service : null;

	}

	return null;

}
function priceFix(service) {
	let price = service ? service.price : null;

	if (price && price.length <= 2) {
		service.price = Number(price).toFixed(2);
	}

	return service;
}

// Season type definitions for multi-locale support
const SEASON_TYPES = {
	allSeason: ['all season', 'all-weather', 'pneu tous climats'],
	summer: ['summer', 'pneu d\'été'],
	winter: ['winter', 'pneu d\'hiver']
};

// Factory function to create season filters
const checkSeasonFilter = (seasonValues) => prods =>
	prods.filter(({ products }) => {
		const productSeason = last(products).season;
		const season = productSeason ? productSeason.toLowerCase() : '';


		return seasonValues.includes(season);
	});

const allSeason = checkSeasonFilter(SEASON_TYPES.allSeason);
const summer = checkSeasonFilter(SEASON_TYPES.summer);
const winter = checkSeasonFilter(SEASON_TYPES.winter);

const fuelEfficient = prods =>
	prods.filter(({ products }) => last(products).ecoTire);

const recommended = prods =>
	prods.filter(product => product.recommended);

const promos = prods =>
	prods.filter(({ products }) => last(products).promotions.length > 0);

const oem = prods =>
	prods.filter(({ products }) => last(products).factoryInstalled);

const filterServices = services => {
	return services.filter(service => priceFix(serviceReducer(service)));
};


module.exports = {
	SEASON_TYPES,
	allSeason,
	summer,
	fuelEfficient,
	winter,
	recommended,
	promos,
	oem,
	filterServices
};
